export class RedirectionToConfirmation {
    public static confirmation_massage = (
        serviceName: string,
        partnerType: string,
        alias: string,
        price: string,
        serviceDate: string,
        firstName: string
    ): void => {
        window.location.href = `https://www.raskrask.dk/bekraeftelse-23-massage/?sn=${serviceName}&pt=${partnerType}&a=${alias}&pr=${price}&sd=${serviceDate}&fn=${firstName}`
    }

    public static confirmation_traening = (
        serviceName: string,
        partnerType: string,
        alias: string,
        price: string,
        serviceDate: string,
        firstName: string
    ): void => {
        window.location.href = `https://www.raskrask.dk/bekraeftelse-23-training/?sn=${serviceName}&pt=${partnerType}&a=${alias}&pr=${price}&sd=${serviceDate}&fn=${firstName}`
    }

    public static confirmation_yoga = (
        serviceName: string,
        partnerType: string,
        alias: string,
        price: string,
        serviceDate: string,
        firstName: string
    ): void => {
        window.location.href = `https://www.raskrask.dk/bekraeftelse-23-yoga/?sn=${serviceName}&pt=${partnerType}&a=${alias}&pr=${price}&sd=${serviceDate}&fn=${firstName}`
    }

    public static confirmation_company = (
        serviceName: string,
        partnerType: string,
        alias: string,
        price: string,
        serviceDate: string,
        firstName: string
    ): void => {
        window.location.href = `https://www.raskrask.dk/bekraeftelse-23-firma/?sn=${serviceName}&pt=${partnerType}&a=${alias}&pr=${price}&sd=${serviceDate}&fn=${firstName}`
    }

    public static confirmation_companyLead = (firstName: string): void => {
        window.location.href = `https://www.raskrask.dk/bekraeftelse-23-firma-lead/?fn=${firstName}`
    }

    public static confirmation_package = (
        address: string,
        customerType: string,
        basisTypeId: number,
        goalId: number,
        serviceTypeId: number,
        profileId: number,
        customerName: string,
        customerPhone: number,
        customerEmail: string
    ): void => {
        window.location.href = `https://www.raskrask.dk/bekraeftelse-23-klippekort/?address=${address}&customerType=${customerType}&basisTypeId=${basisTypeId}&goalId=${goalId}&serviceTypeId=${serviceTypeId}&profileId=${profileId}&customerName=${customerName}&customerPhone=${customerPhone}&customerEmail=${customerEmail}`
    }

    public static confirmation_edit = (
        serviceName: string,
        partnerType: string,
        alias: string,
        serviceDate: string
    ): void => {
        window.location.href = `https://www.raskrask.dk/bekraeftelse-23-edit/?sn=${serviceName}&pt=${partnerType}&a=${alias}&sd=${serviceDate}`
    }

    public static confirmation_cancellation = (): void => {
        window.location.href = 'https://www.raskrask.dk/bekraeftelse-24-aflys/'
    }
}
